import cn from 'classnames'
import React, { ReactNode } from 'react'

import style from './SettingsControlRow.style'

type SettingsControlRowProps = {
  title: string
  description?: string
  /**
   * Row-level failure. Rendered under the description with alert semantics so
   * a failed write is attributed to the control that caused it, rather than to
   * the section as a whole.
   */
  error?: string
  /** Test id for the error node, so a suite can assert WHICH row failed. */
  errorTestId?: string
  /** Right-aligned control (switch, pill + switch, etc.). */
  children?: ReactNode
  className?: string
}

/**
 * A label + description row with a right-aligned control, shared by the
 * Payment channels and Connected capabilities disclosures in the redesigned
 * physical card settings (EX-40354).
 */
export default function SettingsControlRow(
  props: SettingsControlRowProps,
): React.ReactElement {
  const {
    title,
    description,
    error,
    errorTestId,
    children,
    className = '',
  } = props

  return (
    <div className={cn('SettingsControlRow', className)} css={style}>
      <div className="SettingsControlRow-text">
        <div className="SettingsControlRow-title">{title}</div>
        {description && (
          <div className="SettingsControlRow-description">{description}</div>
        )}
        {error !== undefined && (
          <div
            className="SettingsControlRow-error"
            role="alert"
            data-testid={errorTestId}
          >
            {error}
          </div>
        )}
      </div>
      {children && <div className="SettingsControlRow-control">{children}</div>}
    </div>
  )
}
